var app = angular.module("leonardo");

var AccountUserCreatedDialog = function($scope, $state) {
  $scope.onboarding = $state.current.onboarding ? true : false;
  $scope.accountUser = $scope.ngDialogData.accountUser;
  $scope.isSystem = $scope.ngDialogData.system;
};

app.controller('AccountUserCreatedDialog', ['$scope', '$state', AccountUserCreatedDialog]);
